import logger from 'redux-logger';
import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './rootReducer';

const middlewares = [logger];

const store = configureStore({
  reducer: rootReducer(),
  // eslint-disable-next-line no-undef
  devTools: process.env.NODE_ENV === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
});

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  store.replaceReducer(rootReducer(store.asyncReducers));
  return store;
};

export default store;
